import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { AGGREGATED_DIFF_START_FINISH_LEGEND } from '../../../constants/legends';

const AggregatedDiffStartFinishComponent = () => (
    <LegendRenderer config={AGGREGATED_DIFF_START_FINISH_LEGEND} />
);

export const AggregatedDiffStartFinishLegend = withDisplayedLayersCheck(
    AggregatedDiffStartFinishComponent,
    t`Агрегированая разница стартов и финишей за 7 дней`
);
